import QuickBtnGroup from "../../../components/QuickBtnGroup/QuickBtnGroup";
import SubmitModalFlow from "../../../components/SubmitModalFlow/SubmitModalFlow";
import {isPresent} from '../../../utilities/general';
const $ = require('jquery');
import run from '../../../utilities/run';

const guidesRatingSelector = ".guide-article-outer-container";

run(guidesRatingSelector, (guideRatingEl)=>{
  attachGuideRating(guideRatingEl);
});

function attachGuideRating(guideRatingEl){
  
  const guideRatingsEl = guideRatingEl.find('.guides-ratings-content');
  const guideRatings = new QuickBtnGroup(guideRatingsEl);
  const guideRatingsBtn = guideRatingEl.find('.guide-ratings-btn a');
  guideRatingEl.find('#guide-rating-select-message').hide();
  guideRatings.init();
  
  // RESET AVERAGE RATINGS MODAL
  const ratingSubmitModalFlow = new SubmitModalFlow({
    confirmModalTitle: 'Reset Average Rating',
    // confirmModalSubtitle: "Optional Subtitle",
    confirmModalBody: '<div class="q-pad-all-xl">Are you sure you want to reset this guides Average Rating?</div>',
    confirmModalBtnText: 'Reset Rating',
    onConfirmClick: function(){
      // Show Loading Modal      
      ratingSubmitModalFlow.showLoadingModal();

      $.ajax({
        url: $("#displayContent").data("reset-rating-url"),
        datatype:'json',
        data: {
          classPK: guideRatingEl.data("class-pk")
        },
        success: function() {
          ratingSubmitModalFlow.showSuccessModal();
          guideRatingEl.find("#guide-avarage-rating").text("0.0");
          guideRatingEl.find("#guide-total-entries").text("0");
           // Hide All Modals
          setTimeout(function() {
            ratingSubmitModalFlow.hideAllModals();
          }, 3000);
        },
        error: function (error) {
          ratingSubmitModalFlow.showErrorModal();
        }
      });
    }
  });
  
  // INIT MODAL FLOW!
  ratingSubmitModalFlow.init();

  // RESET RATINGS CONFIRM MODAL
  $('.reset-rating-modal-btn').on('click', function() {
    ratingSubmitModalFlow.showConfirmModal();
  });


  guideRatingsBtn.on('click', function(e) {
    e.preventDefault();

    let score = guideRatings.getActiveBtnKey();
    //Check if user has realy select Rating
    
    if(isPresent(score)){
      guideRatingEl.find('.guide-ratings-fail').hide();
      guideRatingsBtn.text('Submitting...');

      $.ajax({
        type: 'post',
        url: "/c/portal/rate_entry",
        datatype:'json',
        data: {
          classPK: guideRatingEl.data("class-pk"),
          score : score,
          className: guideRatingEl.data("class-name"),
          p_auth: Liferay.authToken
        },
        success: function() {
          guideRatingEl.find('.guide-ratings-wrapper').hide();
          guideRatingEl.find('.guide-ratings-success').show();
        },
        error: function (error) {
          ratingSubmitModalFlow.showFailureModal();
        }
      });

    }else{
      guideRatingEl.find('.guide-ratings-fail').show();
    }
  });
}


// WEBPACK FOOTER //
// ./src/pages/hcu/guides/guideRating.js